import { useTheme } from '@mui/material/styles'

import { observer } from 'mobx-react-lite'

import {
  CreditScoreDarkColors,
  CreditScoreLightColors,
  getCreditScoreDetails,
} from '../util/finstrongUtils'

import { DialScoreCard } from './shared/DialScoreCard'
import { Loader, useGlobalCopyStore, useGlobalUiStore } from '../../common'

export interface CreditScoreGraphProps {
  arcRadius: number
  size?: 'L' | 'M' | 'SM'
  healthScore: number
  maxValue?: number
  minValue?: number
  footerCenterContent?: string | number
}
export const CreditScoreGraph = observer(
  ({
    arcRadius,
    size = 'L',
    healthScore,
    maxValue = 850,
    minValue = 300,
    footerCenterContent,
  }: CreditScoreGraphProps) => {
    const theme = useTheme()

    const isDarkMode = theme.palette.mode === 'dark'
    const creditScoreData = [
      {
        id: 1,
        label: 'Poor',
        value: 29,
        color: isDarkMode ? CreditScoreDarkColors.POOR : CreditScoreLightColors.POOR,
      },
      {
        id: 2,
        label: 'Fair',
        value: 25,
        color: isDarkMode ? CreditScoreDarkColors.FAIR : CreditScoreLightColors.FAIR,
      },
      {
        id: 3,
        label: 'Good',
        value: 17,
        color: isDarkMode ? CreditScoreDarkColors.GOOD : CreditScoreLightColors.GOOD,
      },
      {
        id: 4,
        label: 'Very Good',
        value: 17,
        color: isDarkMode ? CreditScoreDarkColors.VERY_GOOD : CreditScoreLightColors.VERY_GOOD,
      },
      {
        id: 5,
        label: 'Exceptional',
        value: 12,
        color: isDarkMode ? CreditScoreDarkColors.EXCEPTIONAL : CreditScoreLightColors.EXCEPTIONAL,
      },
    ]
    const { finstrong: copy } = useGlobalCopyStore()

    const { isCopyLoaded } = useGlobalUiStore()

    if (!isCopyLoaded) return <Loader />

    const { status: creditScoreStatus, color: markerColor = 'none' } = getCreditScoreDetails(
      healthScore,
      isDarkMode,
      copy.credit_score_status,
    )
    return (
      <DialScoreCard
        arcRadius={arcRadius}
        dialScoreData={creditScoreData}
        footerCenterContent={footerCenterContent}
        footerLeftContent={minValue}
        footerRightContent={maxValue}
        healthScore={healthScore}
        healthScoreStatus={creditScoreStatus}
        markerColor={markerColor}
        maxValue={maxValue}
        minValue={minValue}
        size={size}
      />
    )
  },
)
